export default [
  {
    component: 'CNavItem',
    name: '報名資料',
    to: '/registration',
    className: '',
    icon: 'cil_doc_person',
  },
]
